// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
import ComparativeBar from 'components/commons/comparativeBar/comparativeBar';
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';

// @ constants
const TITLE_LIMIT_LENGTH = 20;


export default function CategoryTab({title, code, iconUrl, amount, totalAmount, isSelected, onClick}) {

    const classes = classNames('expenses-by-category-tab-selector__slider__block', { '-selected': isSelected });
    
    const mustRenderTooltip = title => formatText(`categorized-${title}`).length >= TITLE_LIMIT_LENGTH ? true : false;

    const titleSection = (<div className="expenses-by-category-tab-selector__slider__block__icon-title">
        <img src={iconUrl}/>
        <FormattedText className="title" value={`categorized-${title}`} />
    </div>)

    return (
        <div
            className={classes}
            onClick={() => onClick(code)}
        >
            { mustRenderTooltip(title) ?
                <OKTooltip
                    content={`categorized-${title}`}
                    offset={[15, -15]}
                    target={titleSection}
                /> :
                titleSection }
            <div className="expenses-by-category-tab-selector__slider__block__comparative-bar">
                <ComparativeBar
                    slim
                    firstValue={amount}
                    totalValue={totalAmount}
                    className="expenses-by-category-tabs-block__bar"
                />
            </div>
            
        </div>
    )
}

CategoryTab.defaultProps = {
    isSelected: false,
    onClick: () => {}
}

CategoryTab.propTypes = {
    amount: PropTypes.number.isRequired,
    code: PropTypes.number.isRequired,
    iconUrl: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired,
    totalAmount: PropTypes.number.isRequired,
};